/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import RoleManagementContainer from 'modules/role-management/container/RoleManagementContainer';
import UserManagementContainer from 'modules/user-management/UserManagementContainer';



function AccessControlContainer({ match }) {
    return (
      <Switch>
        <Route
          path={`${match.path}/role-management`}
          component={RoleManagementContainer}
        />
        <Route
          path={`${match.path}/user-management`}
          component={UserManagementContainer}
        />
      </Switch>
  );
}

AccessControlContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(AccessControlContainer);